export type TMessage = 'processing' | 'result';
export interface IDialogMessage {
  status?: number;
  message: string;
}
export const RESULT_BASE = {
  information: false,
  success: false,
  redirection: false,
  clientError: false,
  serverError: false
};
